<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./SignUpSuccess.translations.json" with { type: "json" };

	const _ = $props();
	const translate = getTranslate(translations);
</script>

<div class="flex flex-col items-stretch gap-5 md:gap-10 mt-2 md:mt-0">
	<p class="text-fcrgray text-sm/6 md:text-base max-w-127">
		<Formatted text={translate("message")} />
	</p>
</div>
